import { getAddOrGetGroupQueryKey, GidRoleData, RoleOrgGroup, useAddOrGetGroup } from '@isdd/metais-common/api/generated/iam-swagger'
import { HierarchyRightsUi } from '@isdd/metais-common/api/generated/cmdb-swagger'
import React, { useState } from 'react'

export interface PublicAuthorityState {
    selectedPublicAuthority: HierarchyRightsUi | null
    setSelectedPublicAuthority: React.Dispatch<React.SetStateAction<HierarchyRightsUi | null>>
}

export interface RoleState {
    selectedRole: GidRoleData | null
    setSelectedRole: React.Dispatch<React.SetStateAction<GidRoleData | null>>
}

export interface IPublicAuthorityAndRoleReturnType {
    groupData?: RoleOrgGroup
    publicAuthorityState: PublicAuthorityState
    roleState: RoleState
    isLoading: boolean
    isError: boolean
}

export const usePublicAuthorityAndRoleHook = (): IPublicAuthorityAndRoleReturnType => {
    const [selectedPublicAuthority, setSelectedPublicAuthority] = useState<HierarchyRightsUi | null>(null)
    const [selectedRole, setSelectedRole] = useState<GidRoleData | null>(null)

    const {
        data: groupData,
        isLoading,
        isError,
        fetchStatus,
    } = useAddOrGetGroup(selectedRole?.roleUuid ?? '', selectedPublicAuthority?.poUUID ?? '', {
        query: {
            queryKey: getAddOrGetGroupQueryKey(selectedRole?.roleUuid ?? '', selectedPublicAuthority?.poUUID ?? ''),
            enabled: !!selectedRole && !!selectedPublicAuthority,
            retry: false,
        },
    })

    const publicAuthorityState = { selectedPublicAuthority, setSelectedPublicAuthority }
    const selectedRoleState = { selectedRole, setSelectedRole }

    return {
        groupData,
        publicAuthorityState: publicAuthorityState,
        roleState: selectedRoleState,
        isLoading: isLoading && fetchStatus !== 'idle',
        isError: isError,
    }
}
